import React from "react";
import {classByArray} from '../../../functions/function'
import {IconSVG} from "../../../custom/icon/IconSVG";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children?: React.ReactNode
    variant?: 'primary' | 'primary-outline' | 'secondary' | 'secondary-outline' | 'secondary-outline-dark' | 'default' | 'danger' | 'danger-outline'
    className?: string
    icon?: string
    iconSize?: string
    iconRight?: string
    tintColor?: string
}

function BtnDefault({
                        children,
                        variant = 'default',
                        className = '',
                        icon,
                        iconRight,
                        tintColor,
                        iconSize = "16px",
                        ...rest
                    }: ButtonProps) {
    const classList = classByArray(['sh btn', `btn-${variant}`, className])
    return (
        <button type="button" className={classList} {...rest}>
            {icon && <IconSVG icon={icon} size={iconSize} className={`${children ? '' : ''}`}
                              tintColor={tintColor}/>}
            {children}
            {iconRight && (
                <IconSVG icon={iconRight} size={iconSize} className={`${children ? '' : ''}`}
                         tintColor={tintColor}/>
            )}
        </button>
    )
}

export default BtnDefault
